module.exports = __webpack_public_path__ + "static/media/click.c5613a56.wav";